import React from "react";
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';
import WebsiteContentField from '../../components/WebsiteContentField';

export class WebsiteContentLanding extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      website: {},
      heroImage:'',
      welcomeMessage:'Welcome!',
      ctaLinkTypes:[{id:'23415', name:'CTA LINK'}],
      ctaLink:'23415'
    };
  }
  
  onFieldChange = (propertyName, value) => {
    let website = {
      ...this.state.website,
      [propertyName]: value
    };
    this.setState({website});
  }

  render() {
    if (this.props.loading) {
      return  <div style={{textAlign: 'center'}}><CircularProgress/></div>;
    }


    return (
    <div>
      <WebsiteContentField label="Hero Banner" icon="picture" value={this.state.website.heroImage} onChange={(value)=> this.onFieldChange('heroImage', value)} type="photo" finePrint="Recommended size: 1920px width, 600px height - File format: JPG" />
      <WebsiteContentField label="Welcome Message" icon="quote" value={this.state.welcomeMessage} type="richtext" />
      <WebsiteContentField label="CTA Link" icon="link" value={this.state.ctaLink} options={this.state.ctaLinkTypes} type="dropdown" />
    </div>);
  }
}

let mapStateToProps = ({websiteEndpoint},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false
})

let mapDispatchToProps = (dispatch) => ({
  
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(WebsiteContentLanding));





// WEBPACK FOOTER //
// ./src/containers/Website/WebsiteContentLanding.js